import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi
} from "@angular/common/http";
import {ApplicationConfig, provideZoneChangeDetection} from "@angular/core";
import {DateFnsAdapter, MAT_DATE_FNS_FORMATS} from "@angular/material-date-fns-adapter";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {provideRouter, withComponentInputBinding} from "@angular/router";
import {enAU} from 'date-fns/locale';
import {AppComponent} from './app/app.component';
import {routes} from "./app/app.routes";
import {environment} from "./environments/environment";
import {httpErrorInterceptor} from "./app/core/interceptors/http-error-interceptor/http-error.interceptor";
import {MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory,} from "./app/core/auth/msal-config";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from "@azure/msal-angular";
import {MockAuthTokenInterceptor} from "./app/core/interceptors/mock-auth-token.interceptor";

/**
 * Configure auth providers based on environment.
 */
const authProviders = environment.useMockAuth ? [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MockAuthTokenInterceptor,
    multi: true,
  }
] : [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
];

const appConfig: ApplicationConfig = {
  providers: [
    ...environment.providers,
    ...authProviders,
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([httpErrorInterceptor]), withInterceptorsFromDi(), withFetch()),
    {provide: MAT_DATE_LOCALE, useValue: enAU},
    {provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS},
  ]
};

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));
